import { TabBeautyProfile } from 'components/user/user-detail/tab-beauty-profile/TabBeautyProfile'
import { useFetch } from 'services/useFetch'
import { API_USER } from 'services/apiUser'

export const TabBeautyProfileContainer = ({ id }) => {
    const { data: beautyProfile, isLoading } = useFetch(
        {
            ...API_USER.BEAUTY_PROFILE,
            initPathVariable: id,
        },
        {},
        { isFetching: true },
    )

    return <TabBeautyProfile dataBeautyProfile={beautyProfile?.data} isLoading={isLoading} />
}
